import { render, staticRenderFns } from "./ConsultarLotes.vue?vue&type=template&id=6bcacbda&scoped=true&"
import script from "./ConsultarLotes.vue?vue&type=script&lang=js&"
export * from "./ConsultarLotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcacbda",
  null
  
)

export default component.exports